import { Component, Event, EventEmitter, getAssetPath, h, Host, State } from '@stencil/core';

import { GRECAPTCHA_SITEKEY } from '@web-components/constants';
import wcShared from '@web-components/shared';

import { InitStore } from '../../../utils/Stores/init-store';
import { Store } from '../../../utils/Stores/store';

@Component({
  tag: 'report-abuse-module-component',
  styleUrl: 'report-abuse-module.scss',
  shadow: true,
})
export class ModuleReportAbuse {
  @Event() closeEvent: EventEmitter;
  @State() abuseList;
  @State() abuseValue: string[] = [];
  @State() isAbuseValueEmpty = true;
  @State() isAbuseCommentValueEmpty = true;
  @State() abuseComment: string = null;
  @State() abuseProject: string = null;
  @State() abuseUrl: string = null;
  @State() mail: string;
  @State() hasAcceptedDisclaimer = false;
  @State() isInputAlreadyPrefill = false;
  @State() showErrorMessage = false;
  @State() isLoading = false;

  private projects = [
    { name: 'kDrive', value: 'drive' },
    { name: 'SwissTransfer', value: 'swiss_transfer' },
    { name: 'Swiss Backup', value: 'swiss_backup' },
    { name: 'Chk.me', value: 'chk' },
    { name: wcShared.translate('Autre'), value: 'other' },
  ];

  componentWillLoad() {
    const urlParams = new URL(window.location.href).searchParams;

    if (Boolean(urlParams.get('url')) && Boolean(urlParams.get('from'))) {
      this.abuseUrl = urlParams.get('url');
      this.abuseProject = urlParams.get('from');
      this.isInputAlreadyPrefill = true;
    }

    this.abuseList = [
      {
        label: wcShared.translate('Spam, Hameçonnage ou Logiciel Malveillant'),
        value: 'spam_malware_phising',
      },
      {
        label: wcShared.translate('Violence ou Incitation à la haine'),
        value: 'violence_hate_speech',
      },
      {
        label: wcShared.translate('Harcèlement, intimidation ou menaces'),
        value: 'harassment',
      },
      {
        label: wcShared.translate('Violation des droits humains'),
        value: 'human_rights_violations',
      },
      {
        label: wcShared.translate("Usurpation d'identité"),
        value: 'identity_theft',
      },
      {
        label: wcShared.translate("Atteinte aux droits d'auteur / Propriété intellectuelle"),
        value: 'copyright_infringement',
      },
      {
        label: wcShared.translate('Activités illégales'),
        value: 'illegal_activities',
      },
      {
        label: wcShared.translate('Autre'),
        value: 'other',
      },
    ];
  }

  componentDidLoad() {
    this.injectCaptcha();
  }

  private setAbuseValue(value) {
    if (this.abuseValue.includes(value)) {
      this.abuseValue.splice(this.abuseValue.indexOf(value), 1);
    } else {
      this.abuseValue.push(value);
    }

    this.isAbuseValueEmpty = this.abuseValue.length === 0;
  }

  private updateComment(event: Event): void {
    const element = event.currentTarget as HTMLTextAreaElement;
    this.abuseComment = element.value;

    this.isAbuseCommentValueEmpty = this.abuseComment.length === 0;
  }

  private updateProject(event: Event): void {
    const element = event.currentTarget as HTMLSelectElement;
    this.abuseProject = element.value;
  }

  private updateUrl(event: Event): void {
    const element = event.currentTarget as HTMLInputElement;
    this.abuseUrl = element.value;
  }

  private updateMail(event: Event): void {
    const element = event.currentTarget as HTMLInputElement;
    this.mail = element.value;
  }

  private disclaimerChange(event) {
    this.hasAcceptedDisclaimer = event.target.checked;
  }

  private sendReport() {
    this.showErrorMessage = false;
    this.isLoading = true;
    const form = new FormData();
    form.append('url', this.abuseUrl);
    if (this.mail) form.append('email', this.mail);
    this.abuseValue.forEach((slug) => form.append('content_slug[]', slug));
    form.append('service_slug', this.abuseProject);
    form.append('comment', this.abuseComment);

    form.append('g-recaptcha-response', Store?.get('g_recaptcha_response'));

    wcShared
      .httpCall('POST', '/api/components/support/content_report', form, false, true)
      .then((r) => {
        if (r.status === 200) {
          Store?.set('is_report_abuse_sent', true);
        } else {
          this.showErrorMessage = true;
          this.isLoading = false;
        }
      })
      .catch(() => {
        this.showErrorMessage = true;
        this.isLoading = false;
      });
  }

  private getTokenRecaptcha(token) {
    Store?.set('g_recaptcha_response', token);
  }

  private injectCaptcha() {
    const script = document.createElement('script');
    script.src = 'https://google.com/recaptcha/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      const setIntevalLoaded = setInterval(() => {
        if (window['grecaptcha']?.render) {
          try {
            window['grecaptcha']?.render('recaptcha', {
              sitekey: GRECAPTCHA_SITEKEY,
              theme: wcShared?.store?.theme,
              callback: this.getTokenRecaptcha.bind(this),
            });
            clearInterval(setIntevalLoaded);
          } catch (err) {
            console.warn('recaptcha already loaded', err);
          }
        }
      }, 100);
    };
    document.body.appendChild(script);
  }

  render() {
    const isSubmitDisabled =
      this.isAbuseValueEmpty ||
      this.isAbuseCommentValueEmpty ||
      !this.hasAcceptedDisclaimer ||
      !Boolean(this.abuseProject) ||
      !Boolean(this.abuseUrl) ||
      !Store?.get('g_recaptcha_response');
    return (
      <Host>
        {Store?.get('is_report_abuse_sent') ? (
          <div class="report-abuse">
            <img
              src={getAssetPath('./../assets/img/paper-plane.svg')}
              alt={wcShared.translate('Rapport envoye')}
              class="report-sent__img"
            />
            <div class="report-abuse-sent__subtitle text-center">
              {wcShared.translate('Votre signalement a bien ete pris en compte !')}
            </div>
            <div class="report-abuse__text text-center">
              {wcShared.translate(
                'Merci de nous permettre de garantir un web propre et ethique pour tous. Votre signalement a ete transmis a nos equipes qui se chargeront de faire le neccessaire.',
              )}
            </div>
          </div>
        ) : (
          <div class={{ 'report-abuse': true, full: Store?.get('is_full') }}>
            <div class="report-abuse__subtitle">
              {wcShared.translate('Quelle est la raison de votre signalement ?')}
            </div>
            <div>
              {this.abuseList.map((abuse) => (
                <div class="report-abuse__radio">
                  <label class="report-abuse__type">
                    <input
                      class="margin-right-10"
                      onChange={() => this.setAbuseValue(abuse.value)}
                      type="checkbox"
                      name="abuse"
                    ></input>
                    <span class="label">{abuse.label}</span>
                  </label>
                  <br />
                </div>
              ))}

              {/* Textarea Comment */}
              <div class="input-group">
                <label htmlFor="comment">{wcShared.translate('Commentaire')}* :</label>
                <textarea
                  class="report-abuse__comment"
                  id="comment"
                  onKeyPress={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyUp={(e) => {
                    e.stopPropagation();
                  }}
                  value={this.abuseComment}
                  onInput={(e) => this.updateComment(e)}
                  placeholder={wcShared.translate('Entrer le maximum de détails possible')}
                />
              </div>

              {/* Select Project */}
              <div class="input-group">
                <label htmlFor="from">{wcShared.translate('Catégorie')}* :</label>
                <select
                  class="select-from"
                  disabled={this.isInputAlreadyPrefill}
                  onChange={(event) => this.updateProject(event)}
                >
                  <option
                    value=""
                    selected
                    disabled
                    hidden
                  >
                    {wcShared?.translate('Sélectionner la catégorie concernée')}
                  </option>
                  {this.projects.map((project) => {
                    return (
                      <option
                        selected={project.value === this.abuseProject}
                        value={project.value}
                      >
                        {project.name}
                      </option>
                    );
                  })}
                </select>
              </div>

              {/* Input Url */}
              <div class="input-group">
                <label htmlFor="url">{wcShared.translate('Url')}* :</label>
                <input
                  class="report-abuse__url"
                  id="url"
                  type="text"
                  onKeyPress={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyUp={(e) => {
                    e.stopPropagation();
                  }}
                  placeholder={wcShared.translate("Entrer l'url concerné")}
                  disabled={this.isInputAlreadyPrefill}
                  value={this.abuseUrl}
                  onInput={(event) => this.updateUrl(event)}
                />
              </div>

              {!Boolean(InitStore?.get('init')?.user?.id) && (
                <div class="input-group">
                  <label htmlFor="mail">{wcShared.translate('Adresse mail')} :</label>
                  <input
                    id="mail"
                    type="email"
                    onKeyPress={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyUp={(e) => {
                      e.stopPropagation();
                    }}
                    placeholder={wcShared.translate('Entrer votre adresse mail')}
                    onInput={(event) => this.updateMail(event)}
                  />
                </div>
              )}

              {/* Checkbox Disclaimer */}
              <div class="report-abuse__disclaimer">
                <label class="report-abuse__type">
                  <input
                    class="margin-right-10"
                    onChange={(e) => this.disclaimerChange(e)}
                    type="checkbox"
                    name="disclaimer"
                  ></input>
                  <span class="label">
                    {wcShared.translate(
                      "Le client comprend et accepte que l'établissement d'un signalement n'engage pas Infomaniak Network SA à prendre une quelconque action au regard du lien signalé. Infomaniak procèdera à l'analyse du signalement, et, en toute bonne foi et conformément aux conditions générales, prendra la décision qu'elle jugera adaptée.",
                    )}
                  </span>
                </label>
              </div>

              <div class="g-recaptcha">
                <slot name="recaptcha-slot-4" />
              </div>

              <div class="report-abuse__actions">
                <button
                  type="button"
                  // eslint-disable-next-line @typescript-eslint/naming-convention
                  class={{ button__primary: true, disabled: isSubmitDisabled }}
                  onClick={() => this.sendReport()}
                  disabled={isSubmitDisabled}
                >
                  {this.isLoading ? (
                    <img
                      height="20"
                      width="194"
                      src={getAssetPath('./../assets/img/loader-ripple.svg')}
                      alt={wcShared.translate('chargement')}
                    />
                  ) : (
                    wcShared.translate('Envoyer le signalement')
                  )}
                </button>
              </div>
              <div class={{ 'error-message': true, hide: !this.showErrorMessage }}>
                {wcShared.translate(
                  'Une erreur est survenue, merci de ressayer dans quelques instants',
                )}
              </div>
            </div>
          </div>
        )}
      </Host>
    );
  }
}
